import { render, staticRenderFns } from "./changeHandler.vue?vue&type=template&id=2c3434c5&scoped=true&"
import script from "./changeHandler.vue?vue&type=script&lang=js&"
export * from "./changeHandler.vue?vue&type=script&lang=js&"
import style0 from "./changeHandler.vue?vue&type=style&index=0&id=2c3434c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3434c5",
  null
  
)

export default component.exports